import { Button, Modal } from "antd";
import { useState } from "react";
import "./ConfirmationModal.scss";
import AccountsApi from "../../api/AccountsApi";
import { AddOnDtoTypeEnum } from "../../generated/dashboard-client";
import { useRecoilValue } from "recoil";
import { memberState } from "../../state/atoms";

export interface DeactivateScreenModalProps {
  it: number;
  isVisible: boolean;
  onClose: (fetch: boolean) => void;
}

export function DeactivateScreenModal({
                                        it,
                                        isVisible,
                                        onClose
                                      }: DeactivateScreenModalProps) {
  const [loading, setLoading] = useState(false);
  const member = useRecoilValue(memberState);

  async function deactivateScreen() {
    setLoading(true);
    await AccountsApi.removeSubscriptionAddon(member.id, AddOnDtoTypeEnum.Dsa);
    setLoading(false);
    onClose(true);
  }

  return (
    <Modal
      className={"confirmation-modal clean"}
      open={isVisible}
      onCancel={() => onClose(false)}
    >
      <header>
        <h2>Are you sure you want to deactivate the license for Screen {it + 1}?</h2>
      </header>

      <p>A deactivated license will not be billed at your next renewal.<br/>To add a new screen with this license, reactivate the license first.</p>

      <footer>
        <Button size={"large"} onClick={() => onClose(false)}>
          Cancel
        </Button>
        <Button
          size={"large"}
          className={"primary"}
          onClick={() => deactivateScreen()}
          loading={loading}
        >
          Deactivate
        </Button>
      </footer>
    </Modal>
  );
}
